import React from 'react';
//scss
import './Footer.scss';
//icon
import Multiwave from '../Icons/multiwave';

class Footer extends React.Component {
  render() {
    return <div className="Footer"></div>;
  }
}

export default Footer;
